import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { ViajesService } from '../../services/Viajes/ViajesService';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';

const obtenerPosicionActual = () => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error("Tu navegador no soporta geolocalización."));
        } else {
            // Timeout de 5s para no dejar colgado al usuario si el GPS tarda
            navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000 });
        }
    });
};

const ListaViajesActivos = () => {
    const toast = useRef(null);

    const viajesService = new ViajesService();

    const [viajes, setViajes] = useState([]);
    const [ubicaciones, setUbicaciones] = useState([]);
    const [tarjetas, setTarjetas] = useState([]);

    const [viajeSeleccionado, setViajeSeleccionado] = useState(null);
    const [ubicacionSeleccionada, setUbicacionSeleccionada] = useState(null);
    const [tarjetaSeleccionada, setTarjetaSeleccionada] = useState([]);
    const [accionSeleccionada, setAccionSeleccionada] = useState(null);
    const [usuarioResponsableSeleccionado, setUsuarioResponsableSeleccionado] = useState(null);
    const [userId, setUserId] = useState(null);


    const [visible, setVisible] = useState(false);

    const [loadingViajes, setLoadingViajes] = useState(true);
    const [loadingUbicaciones, setLoadingUbicaciones] = useState(true);
    const [loadingTarjetas, setLoadingTarjetas] = useState(false);
    const [loadingUsuariosResponsables, setLoadingUsuariosResponsables] = useState(true);

    const [usuariosResponsables, setUsuariosResponsables] = useState([]);
    const [token, setToken] = useState(null);
    const [mensajeRespuesta, setMensajeRespuesta] = useState("");


    useEffect(() => {
        viajesService.obtenerViajesActivos().then((res) => {
            const viajesConLabel = res.data.map((v) => ({
                ...v,
                label: `${v.booking ?? ''} - ${v.vehiculo ?? ''}`
            }));
            setViajes(viajesConLabel);
            setLoadingViajes(false);
        });

        viajesService.obtenerUbicacionesActivas().then((res) => {
            const ubicacionesConLabel = res.data.map((u) => ({
                ...u,
                label: `${u.codigo ?? ''} - ${u.nombre ?? ''}`
            }));
            setUbicaciones(ubicacionesConLabel);
            setLoadingUbicaciones(false);
        });
    }, []);

    useEffect(() => {
        let _userId = localStorage.getItem('userId');
        setUserId(_userId);
    }, [])
    useEffect(() => {
        viajesService.obtenerCodigoAutorizacionResponsable().then((res) => {
            setUsuariosResponsables(res.data);
            setLoadingUsuariosResponsables(false);

        })
    }, [])

    useEffect(() => {
        if (ubicacionSeleccionada?.ubicacionId) {
            setLoadingTarjetas(true);
            viajesService
                .obtenerTarjetasPorUbicacion(ubicacionSeleccionada.ubicacionId)
                .then((response) => {
                    if (Array.isArray(response)) {
                        setTarjetas(response);
                    } else {
                        console.error('Respuesta inesperada de tarjetas:', response);
                        setTarjetas([]);
                    }
                })
                .catch((err) => {
                    console.error('Error al obtener tarjetas:', err);
                    setTarjetas([]);
                })
                .finally(() => setLoadingTarjetas(false));
            setTarjetaSeleccionada([]);
        } else {
            setTarjetas([]);
            setTarjetaSeleccionada([]);
        }
    }, [ubicacionSeleccionada]);

    const obtenerUbicacion = () => {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            latitud: position.coords.latitude,
                            longitud: position.coords.longitude
                        });
                    },
                    (error) => {
                        console.error('Error al obtener ubicación:', error);
                        resolve({ latitud: null, longitud: null });
                    }
                );
            } else {
                console.warn('Geolocalización no soportada');
                resolve({ latitud: null, longitud: null });
            }
        });
    };


    const enviarComando = async () => {
        // La validacion de IP y de area ahora se hace en el BACKEND (toggles en
        // configuracion_det: VALIDAR_IP_COMANDO / VALIDAR_AREA_COMANDO). Aca solo
        // capturamos la ubicacion del navegador (si el area esta activa, el backend
        // la exige; si esta apagada, la ignora). Si el backend rechaza, responde 403
        // y el mensaje se muestra en el catch de abajo.
        const ubicacion = await obtenerUbicacion();

        const payload = [
            { parametro: 'viajeId', valor: viajeSeleccionado?.viajeId ?? '' },
            { parametro: 'ubicacionId', valor: ubicacionSeleccionada?.ubicacionId ?? '' },
            { parametro: 'tarjetaId', valor: tarjetaSeleccionada.map(t => t.id).join(',') },
            { parametro: 'accion', valor: accionSeleccionada ?? '' },
            { parametro: 'usuarioId', valor: userId ?? '' },
            { parametro: 'usuarioResponsableId', valor: usuarioResponsableSeleccionado?.usuarioId ?? '' },
            { parametro: 'latitud', valor: ubicacion.latitud ?? '' },
            { parametro: 'longitud', valor: ubicacion.longitud ?? '' },
            { parametro: 'codigoAutorizacion', valor: token ?? '' }
        ];

        try {
            console.log("Payload final:", payload);

            // 4. Enviar al Backend (Usando tu ViajesService existente)
            const response = await viajesService.enviarComando(payload);

            setMensajeRespuesta(response);
            toast.current.show({
                severity: 'success',
                summary: 'Comando Enviado',
                detail: 'El comando fue autorizado y enviado correctamente. ',
                life: 3000
            });

            setVisible(false);


        } catch (error) {
            console.error("Error envío:", error);

            let mensaje = "Error al procesar solicitud.";

            // 6. Manejar el error 403 de Geofencing
            if (error.response && error.response.status === 403) {
                mensaje = error.response.data || "Estás fuera de la zona permitida.";
            } else if (error.message) {
                mensaje = error.message;
            }

            toast.current.show({ severity: 'error', summary: 'Error', detail: mensaje });
        }

    

    };

    // 🔝 Coloca la helper encima de enviarComando (dentro del componente)
    const buildPayload = (coords = { latitud: '', longitud: '' }) => [
        { parametro: 'viajeId', valor: viajeSeleccionado?.viajeId ?? '' },
        { parametro: 'ubicacionId', valor: ubicacionSeleccionada?.ubicacionId ?? '' },
        { parametro: 'tarjetaId', valor: tarjetaSeleccionada.map(t => t.id).join(',') },
        { parametro: 'accion', valor: accionSeleccionada ?? '' },
        { parametro: 'usuarioId', valor: userId ?? '' },
        { parametro: 'usuarioResponsableId', valor: usuarioResponsableSeleccionado?.usuarioId ?? '' },
        { parametro: 'latitud', valor: coords.latitud ?? '' },
        { parametro: 'longitud', valor: coords.longitud ?? '' },
        { parametro: 'codigoAutorizacion', valor: token ?? '' }
    ];

    

    const handleGenerarToken = async () => {
        if (!viajeSeleccionado || !ubicacionSeleccionada
            || !usuarioResponsableSeleccionado) {
            toast.current.show({
                severity: 'warn',
                summary: 'Faltan datos',
                detail: 'Debes seleccionar viaje, ubicación, tarjeta y usuario responsable.',
                life: 3000
            });
            return;
        }

        const payload = [
            { parametro: 'ubicacionId', valor: String(ubicacionSeleccionada.ubicacionId) },
            { parametro: 'tarjetaId', valor: tarjetaSeleccionada.map(t => t.id).join(',') },
            { parametro: 'viajeId', valor: String(viajeSeleccionado.viajeId) },
            { parametro: 'accion', valor: String(accionSeleccionada) },
            { parametro: 'usuarioId', valor: String(userId) },
            { parametro: 'usuarioResponsableId', valor: String(usuarioResponsableSeleccionado.usuarioId) }
        ];

        console.log('Payload para generar token:', payload);

        try {
            const respuesta = await viajesService.solicitarToken(payload);
            console.log('Respuesta del backend:', respuesta);
            toast.current.show({
                severity: 'success',
                summary: 'Token generado',
                detail: 'Token generado correctamente.',
                life: 3000
            });
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo generar el token.',
                life: 4000
            });
        }
    };

    const accionesDisponibles = [
        { label: 'Agregar', value: 'agregar_masivo' },
        { label: 'Eliminar', value: 'eliminar_masivo' },
        { label: 'Eliminar Todo', value: 'eliminar_todo' },
        { label: 'Apertura Remota', value: 'apertura_remota' },
        { label: 'Consulta Tarjetas Agregas', value: 'consulta_tarjetas_agregas' },
    ];

    const accionesSinTarjetas = [
        'eliminar_todo',
        'apertura_remota',
        'consulta_tarjetas_agregas'
    ];

    //  true  ⇒  el MultiSelect aparecerá deshabilitado
    const tarjetasDisabled = accionesSinTarjetas.includes(accionSeleccionada);






    return (
        <div className="card">
            <Toast ref={toast} />
            <h5>Enviar Comando</h5>
            <div className="formgrid grid p-fluid mb-3">
                {/* VIAJES */}
                <div className="field col-12 md:col-4">
                    <label>Viaje</label>
                    {loadingViajes ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />

                        </div>
                    ) : (
                        <Dropdown
                            value={viajeSeleccionado}
                            onChange={(e) => setViajeSeleccionado(e.value)}
                            options={viajes}
                            placeholder="Selecciona un viaje"
                            optionLabel="label"
                            filter
                            showClear
                        />



                    )}
                </div>

                {/* UBICACIONES */}
                <div className="field col-12 md:col-4">
                    <label>Ubicación</label>
                    {loadingUbicaciones ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />

                        </div>
                    ) : (
                        <Dropdown
                            value={ubicacionSeleccionada}
                            onChange={(e) => setUbicacionSeleccionada(e.value)}
                            options={ubicaciones}
                            optionLabel="label"
                            placeholder="Selecciona una ubicación"
                            filter={true}
                        />
                    )}
                </div>

                {/* TARJETAS */}
                <div className="field col-12 md:col-4">
                    <label>Tarjetas</label>
                    {loadingTarjetas ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <MultiSelect
                            value={tarjetaSeleccionada}
                            onChange={(e) => {
                                const nuevas = e.value;

                                // Regla: si acción es apertura_remota no permitir más de una tarjeta
                                if (accionSeleccionada === 'apertura_remota' && nuevas.length > 1) {
                                    toast.current.show({
                                        severity: 'warn',
                                        summary: 'Máximo 1 tarjeta',
                                        detail: 'Para apertura remota solo se permite una tarjeta.',
                                        life: 3000
                                    });
                                    return;
                                }

                                // Si se borran todas, también limpiamos la acción
                                if (nuevas.length === 0) {
                                    setAccionSeleccionada(null);
                                }

                                setTarjetaSeleccionada(nuevas);
                            }}
                            options={tarjetas}
                            optionLabel="titulo"
                            placeholder="Selecciona tarjetas"
                            disabled={tarjetasDisabled || !ubicacionSeleccionada}  // Deshabilitar si no hay ubicación seleccionada o si la acción no requiere tarjetas
                            filter
                            display="chip"
                        />

                    )}
                </div>


                {/* USUARIOS RESPONSABLES */}
                <div className="field col-12 md:col-4">
                    <label>Usuario Responsable</label>
                    {loadingUsuariosResponsables ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />

                        </div>
                    ) : (
                        <Dropdown
                            value={usuarioResponsableSeleccionado}
                            onChange={(e) => setUsuarioResponsableSeleccionado(e.value)}
                            options={usuariosResponsables}
                            optionLabel="nombre"
                            placeholder="Seleccionar un usuario responsable"
                            disabled={loadingUsuariosResponsables}
                            filter={true}
                        />
                    )}
                </div>

                {/* ACCION */}
                <div className="field col-12 md:col-4">
                    <label>Accion</label>

                    <Dropdown
                        value={accionSeleccionada}
                        onChange={(e) => {
                            const nuevaAccion = e.value;

                            // Si la nueva acción no requiere tarjetas, vaciamos la selección
                            if (accionesSinTarjetas.includes(nuevaAccion)) {
                                setTarjetaSeleccionada([]);
                            }

                            setAccionSeleccionada(nuevaAccion);
                        }}
                        options={accionesDisponibles}
                        optionLabel="label"
                        placeholder="Selecciona una acción"
                        disabled={(!viajeSeleccionado && !ubicacionSeleccionada)}
                        filter

                    />

                </div>

                {/* GENERAR TOKEN */}
                {accionSeleccionada === 'apertura_remota' && (
                    <div className="field col-12 md:col-2">
                        <label>&nbsp;</label>
                        <Button
                            label="Generar Token"
                            icon="pi pi-send"
                            onClick={handleGenerarToken}
                            disabled={
                                !viajeSeleccionado ||
                                !ubicacionSeleccionada ||
                                !usuarioResponsableSeleccionado
                            }
                        />
                    </div>
                )}

                {/* INPUT TOKEN */}
                {accionSeleccionada === 'apertura_remota' && (
                    <div className="field col-12 md:col-2">
                        <label>&nbsp;</label>
                        <input
                            type="text"
                            placeholder="Token"
                            className="p-inputtext p-component"
                            value={token}
                            onChange={(e) => setToken(e.target.value)}

                        />

                    </div>
                )}

                {/* BOTÓN */}
                <div className="field col-12">
                    <Button
                        label="Abrir diálogo"
                        icon="pi pi-send"
                        onClick={async () => {
                            // Si quieres incluir coordenadas reales:
                            const coords = await obtenerUbicacion();   // devuelve {latitud, longitud}
                            const draft = buildPayload(coords);
                            console.log('⚡ Payload (preview):', draft);

                            setVisible(true);
                        }}
                        disabled={
                            !viajeSeleccionado ||
                            !ubicacionSeleccionada ||
                            !accionSeleccionada ||
                            (
                                ['agregar_masivo', 'eliminar_masivo'].includes(accionSeleccionada) &&
                                tarjetaSeleccionada.length === 0
                            )
                        }
                    />
                </div>

                {/* MENSAJE */}
                <div className="field col-12 md:col-4">
                    <label>MENSAJE DE RESPUESTA</label>

                    <InputTextarea
                        value={mensajeRespuesta}
                    />

                </div>
            </div>

            <Dialog
                header="Enviar Comando"
                visible={visible}
                style={{ width: '25rem' }}
                onHide={() => setVisible(false)}
                modal
                footer={
                    <Button
                        label="Enviar comando"
                        icon="pi pi-check"
                        className="w-full"
                        onClick={enviarComando}
                        disabled={
                            !viajeSeleccionado ||
                            !ubicacionSeleccionada ||
                            !accionSeleccionada ||
                            !usuarioResponsableSeleccionado
                        }
                    />
                }
            >
                <div className="p-2">
                    <p><strong>Viaje:</strong> {viajeSeleccionado?.booking}</p>
                    <p><strong>Ubicación:</strong> {ubicacionSeleccionada?.nombre}</p>
                    <p><strong>Tarjetas:</strong> {(tarjetaSeleccionada ?? []).map(t => t.titulo).join(', ')}</p>
                    <p><strong>Acción:</strong> {accionSeleccionada}</p>
                    <p><strong>Usuario Responsable:</strong> {usuarioResponsableSeleccionado?.nombre}</p>
                    <p><strong>Token:</strong> {token}</p>

                </div>
            </Dialog>
        </div>
    );
};

export default ListaViajesActivos;
